export const SET_FETCHING = "SET_FETCHING";
export const SET_REFETCHING = "SET_REFETCHING";

export const SET_FETCH_SUCCESS = "SET_FETCH_SUCCESS";
export const SET_FETCH_ERROR = "SET_FETCH_ERROR";

export const SET_REFETCH_ERROR = "SET_REFETCH_ERROR";

export const SET_CITIESFETCHING = "SET_CITIESFETCHING";
export const SET_RECITIESFETCHING = "SET_RECITIESFETCHING";


export const SET_CITIESFETCH_SUCCESS = "SET_CITIESFETCH_SUCCESS";
export const SET_CITIESFETCH_ERROR = "SET_CITIESFETCH_ERROR";

export const SET_RECITIESFETCH_ERROR = "RESET_CITIESFETCH_ERROR";

export const SET_DATE_TIME = "SET_DATE_TIME";
export const SET_SHOWERROR = "SET_SHOWERROR";
export const ADDTO_MYCITIES = "ADDTO_MYCITIES";
export const REMOVEFROM_MYCITIES = "REMOVEFROM_MYCITIES";
export const SET_CITIESSHOWERROR = "SET_CITIESSHOWERROR";


